import { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { categories } from "@/mocks/categories";

export default function CategoryDropdown() {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    function handleClick(e: MouseEvent) {
      if (ref.current && !ref.current.contains(e.target as Node)) {
        setOpen(false);
      }
    }
    document.addEventListener("mousedown", handleClick);
    return () => document.removeEventListener("mousedown", handleClick);
  }, []);

  return (
    <div className="relative w-full" ref={ref}>
      <button
        type="button"
        onClick={() => setOpen((o) => !o)}
        className="flex w-full items-center justify-between gap-3 rounded-full border border-background-200 bg-background-50 px-5 py-3.5 text-left text-sm text-foreground-700 transition-colors hover:border-background-300 cursor-pointer"
      >
        <span className="flex items-center gap-2.5">
          <span className="flex h-5 w-5 items-center justify-center text-primary-600">
            <i className="ri-search-line text-lg" />
          </span>
          <span className="whitespace-nowrap">{t("cat.dropdownPlaceholder")}</span>
        </span>
        <span className="flex h-4 w-4 items-center justify-center text-foreground-400">
          <i className={`ri-arrow-down-s-line text-lg transition-transform ${open ? "rotate-180" : ""}`} />
        </span>
      </button>

      {open && (
        <div className="absolute left-0 right-0 top-full z-40 mt-2 max-h-80 overflow-y-auto rounded-lg border border-background-200 bg-background-50 py-1.5">
          {categories.map((cat) => (
            <a
              key={cat.id}
              href={cat.url}
              target="_blank"
              rel="noopener nofollow"
              onClick={() => setOpen(false)}
              className="flex items-center justify-between gap-3 whitespace-nowrap px-4 py-2.5 text-sm text-foreground-800 transition-colors hover:bg-background-100"
            >
              <span>{t(`cat.${cat.id}`)}</span>
              <span className="flex h-3.5 w-3.5 items-center justify-center text-foreground-400">
                <i className="ri-arrow-right-up-line text-sm" />
              </span>
            </a>
          ))}
        </div>
      )}
    </div>
  );
}